import { Drawer, Typography } from "@mui/material";
import React, { useState } from "react";
import "./menudrawer.scss";
import closeIcon from "../../../assets/images/closeIcon.svg";
import shieldCheckMark from "../../../assets/images/shieldCheckMark.svg";
import privacyIcon from "../../../assets/images/privacyIcon.svg";
import termAndCondition from "../../../assets/images/termAndCondition.svg";
import aboutUs from "../../../assets/images/aboutUs.svg";
import contactSupport from "../../../assets/images/contactSupport.svg";
import logout from "../../../assets/images/lagout.svg";
import forwardArrow from "../../../assets/images/forwardArrow.svg";
import {
  getPrivacyPolicyUrl,
  getTermsUrl,
  getAboutUsUrl,
  getContactUsUrl,
} from "../../../configs/environment";
import { Link } from "react-router-dom";
import LogoutConfirmation from "../../modals/LogoutConfirmation";
import { isWebView, openExternalUrl } from "../../../utlis/webViewBridge";
import { useT } from "../../../i18n/useT";
import { useLocale } from "../../../i18n/I18nProvider";
import LanguageSwitcher from "../../common/LanguageSwitcher";
import ExternalWebView from "../../common/ExternalWebView";

const MenuDrawer = ({ openMenuDrawer, setOpenMenuDrawer, user }) => {
  const { locale } = useLocale();
  const [logoutPopUp, setLogoutPopUp] = useState(false);
  const [externalPage, setExternalPage] = useState(null);
  const t = useT("landing");
  const menuListItem = [
    {
      id: "privacy",
      icon: privacyIcon,
      header: t("privacy_policy"),
      description: t("subtitle_privacy_policy"),
      link: getPrivacyPolicyUrl(locale),
    },
    {
      id: "terms",
      icon: termAndCondition,
      header: t("terms_Condition"),
      description: t("subtitle_terms_condition"),
      link: getTermsUrl(locale),
    },
    {
      id: "about",
      icon: aboutUs,
      header: t("about_us"),
      description: t("subtitle_about_us"),
      link: getAboutUsUrl(locale),
    },
    {
      id: "contact",
      icon: contactSupport,
      header: t("contact_support"),
      description: t("subtitle_contact_us"),
      link: getContactUsUrl(locale),
    },
    {
      id: "logout",
      icon: logout,
      header: t("logouttext"),
      description: t("subtitle_logout"),
    },
  ];
  const openExternalLink = (url, title) => {
    if (isWebView()) {
      setExternalPage({ url, title });
      return;
    }
    openExternalUrl(url);
  };

  const logoputHandler = (item) => {
    if (item.id === "logout") {
      setOpenMenuDrawer(false);
      setLogoutPopUp(true);
    } else {
      setOpenMenuDrawer(false);
      openExternalLink(item.link, item.header);
    }
  };

  return (
    <>
      <Drawer
        anchor={"left"}
        open={openMenuDrawer}
        onClose={setOpenMenuDrawer}
        className="menu-drawer-wrapper"
      >
        <div className="main-wrap">
          <div className="close-wrapper">
            <img
              src={closeIcon}
              className="close-icon"
              onClick={setOpenMenuDrawer}
              alt="close"
            />
          </div>
          <div className="menu-header-wrapper">
            <img src={user?.picture} alt="user" className="user-icon" />
            <div className="header-title-wrapper">
              <div className="sub-header-menu">
                <Typography className="title">{user?.name}</Typography>
                <div className="abc"> </div>
                <img src={shieldCheckMark} alt="checkmark" />
              </div>
              <Typography className="email-info">{user?.email}</Typography>
            </div>
          </div>
          <div className="dashed-line" />
          {menuListItem.map((item, index) => {
            return (
              <Link
                to={item.id !== "logout" ? item?.link : "#"}
                key={index}
                className="navigate-block"
                onClick={(e) => {
                  e.preventDefault();
                  logoputHandler(item);
                }}
              >
                <div className="menu-list-wrapper">
                  <div className="menu-item">
                    <img src={item.icon} alt="icon" />
                    <div className="menu-item-header">
                      <Typography className="title">{item.header}</Typography>
                      <Typography className="info">
                        {item.description}
                      </Typography>
                    </div>
                  </div>
                  <div>
                    {/* <Link to={item.header !== "Logout" && item.link}> */}
                    <img src={forwardArrow} alt="arrow" />
                    {/* </Link> */}
                  </div>
                </div>
              </Link>
            );
          })}
          <div className="dashed-line" />
          <LanguageSwitcher />
        </div>
      </Drawer>
      <ExternalWebView
        page={externalPage}
        onClose={() => setExternalPage(null)}
      />
      <LogoutConfirmation setlogout={setLogoutPopUp} logout={logoutPopUp} />
    </>
  );
};

export default MenuDrawer;
